import { useQuery } from '@apollo/react-hooks';

import { SYLLABUS_MODE } from 'Domains/syllabus';
import { getCourseUnitReport, getTKCourseUnitReport } from 'GraphQL/queries/report.query';

const CourseUnitReportData = ({ value, schoolCode, children }) => {
  const { term, grade, classNo, subject, syllabus, mode } = value;

  const variables = {
    schoolTermId: term,
    schoolGradeId: grade !== `all-grade-selected` ? grade : null,
    classNo: classNo !== `all-class-selected` ? classNo : null,
    subjectId: subject,
    courseCode: syllabus,
    schoolCode,
  };

  const isSkip = !term || !grade || !classNo || !subject || !syllabus || !schoolCode;

  const traditionalReport = useQuery(getCourseUnitReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TUNGKAI,
    notifyOnNetworkStatusChange: true,
  });

  const tungkaiReport = useQuery(getTKCourseUnitReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TRADITIONAL,
    notifyOnNetworkStatusChange: true,
  });

  const report = mode === SYLLABUS_MODE.TRADITIONAL ? traditionalReport : tungkaiReport;

  const { loading, error, data, refetch, networkStatus } = report;
  return children({ loading, error, data, refetch, networkStatus });
};

export default CourseUnitReportData;
